<template>
  <div id="deliveryNote" class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-col-gutter-md justify-center">
        <div class="col-12 corner">
          <q-btn
            color="primary"
            @click="toMakeDelivery"
            label="开送货单"
            icon="payment"
          />
        </div>
        <div class="col-md-3 col-11">
          <q-select
            outlined
            v-model="queryForm.customerNo"
            :options="customerList"
            option-label="customerName"
            option-value="customerNo"
            emit-value
            map-options
            label="客户"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-input
            outlined
            v-model="queryForm.noteNo"
            label="送货单号"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-input
            outlined
            v-model="queryForm.cylNo"
            label="缸号"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-input
            outlined
            v-model="queryForm.expressNo"
            label="物流编号"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-input
            outlined
            dense
            v-model="queryForm.beginTime"
            label="发货开始日期"
            clearable
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  ref="qDateProxy"
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date v-model="queryForm.beginTime" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-input
            outlined
            dense
            v-model="queryForm.endTime"
            label="发货结束日期"
            clearable
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  ref="qDateProxy"
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date v-model="queryForm.endTime" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn
            label="重置"
            type="reset"
            color="primary"
            flat
            class="q-ml-sm"
          />
        </div>
      </div>
    </q-form>

    <q-table
      ref="mytable"
      title="送货信息"
      :data="tableData.list"
      :columns="columns"
      row-key="id"
      :pagination.sync="pagination"
      :loading="loading"
      @request="request"
      binary-state-sort
      separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]"
    >
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn
              round
              color="primary"
              size="xs"
              icon="edit"
              @click="detail(props.row)"
            />
            <q-btn
              round
              color="deep-orange"
              size="xs"
              icon="delete_forever"
              @click="remove(props.row)"
            />
          </div>
        </q-td>
      </template>
      <template v-slot:bottom-row>
        <q-tr v-if="tableData.sumMap">
          <q-td align="center"> 合计 </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_PRODUCT_WEIGHT).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_NET_WEIGHT).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import { listAll } from "@/api/erp/customer";
import { remove, list } from "@/api/erp/delivery";
import numbro from "numbro";
export default {
  components: {},
  created() {
    console.log(123);
  },
  data() {
    return {
      numbro,
      queryForm: {},
      tableData: {},
      loading: false,
      customerList: [],
      pagination: {
        sortBy: "DELIVERY_DATE",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "noteNo",
          align: "center",
          label: "送货单号",
          field: (row) => row.noteNo,
        },
        {
          name: "customerName",
          align: "center",
          label: "客户名称",
          field: (row) => row.customer.customerShortName,
        },
        {
          name: "DELIVERY_DATE",
          align: "center",
          label: "送货日期",
          field: "deliveryDate",
          sortable: true,
        },
        {
          name: "expressCompany",
          align: "center",
          label: "物流公司",
          field: "expressCompany",
        },
        {
          name: "expressNo",
          align: "center",
          label: "物流编号",
          field: "expressNo",
        },
        {
          name: "productWeight",
          align: "center",
          label: "投染数(kg)",
          field: (row) =>
            numbro(row.productWeight || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "netWeight",
          align: "center",
          label: "净重(kg)",
          field: (row) =>
            numbro(row.netWeight || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "remark",
          align: "center",
          label: "备注",
          field: "remark",
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },
  mounted() {
    this.query();
    this.listCustomer();
  },
  methods: {
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: "DELIVERY_DATE",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      if (sortBy) {
        self.queryForm.orderBy = sortBy + (descending ? " desc" : " asc");
      }else{
        self.queryForm.orderBy = null;
      }
      list(self.queryForm).then(function (response) {
        self.tableData = response.data.data;
        self.pagination.rowsNumber = self.tableData.total;
        // don't forget to update local pagination object
        self.pagination.page = page;
        self.pagination.rowsPerPage = rowsPerPage;
        self.pagination.sortBy = sortBy;
        self.pagination.descending = descending;
        // ...and turn of loading indicator
        self.loading = false;
      });
    },
    toMakeDelivery() {
      this.$router.push("/delivery/create/");
    },
    detail(row) {
      this.$router.push("/delivery/detail/" + row.id);
    },
    remove(row) {
      var self = this;
      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "此操作将永久删除该条记录, 是否继续?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          console.log(">>>> OK");
          remove(row.id).then(function () {
            self.$q.notify({ type: "positive", message: "删除成功" });
            self.query();
          });
        })
        .onCancel(() => {
          self.$q.notify({ type: "info", message: "已取消删除" });
        })
        .onDismiss(() => {
          console.log("I am triggered on both OK and Cancel");
        });
    },
    listCustomer() {
      var self = this;
      listAll().then((response) => {
        self.customerList = response.data.data;
      });
    },
  },
};
</script>

<style scoped>
.corner {
  flex-direction: row-reverse;
  display: flex;
}
#queryForm {
  /* margin-top: 20px; */
  margin-bottom: 20px;
}
</style>
